module.exports = __webpack_public_path__ + "static/img/gywm_dt.82ad527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/gywm_dt.png
// module id = EmV7
// module chunks = 1